import { CommonConstants } from "@commonClient/src/utils/CommonConstants";
import Rive, { Alignment, Fit, Layout } from "@rive-app/react-canvas-lite";
import React from "react";

export const RavenOnCloudAnimation = () => {
    const animationSrc = CommonConstants.ravenDBAnimationsUrl + "cloud-sitting.riv";
    const layout = new Layout({
        fit: Fit.Cover,
        alignment: Alignment.TopCenter,
    });
    return <Rive src={animationSrc} layout={layout} stateMachines="State Machine 1" />;
};
